import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

/**
 * Converts UNIX timestamp to JST (Japan Standard Time) string
 * @param unix - UNIX timestamp in milliseconds
 * @returns Formatted date string in JST
 */
interface UnixToJSTOptions {
  unix_milliseconds: number;
  format?: string;
}
export const unixToJST = (options: UnixToJSTOptions) => {
  const date = new Date(options.unix_milliseconds);
  const jstDate = toZonedTime(date, "Asia/Tokyo");
  return format(jstDate, options.format ?? "yyyy年MM月dd日");
};
